import { Field } from "./fields";

export const ContactoTab = ({ draft, setDraft }) => {
  const c = draft.contact || {};
  const s = draft.socials || {};
  const setC = (patch) => setDraft({ ...draft, contact: { ...c, ...patch } });
  const setS = (patch) => setDraft({ ...draft, socials: { ...s, ...patch } });
  const digits = `${(c.countryCode || "1").replace(/\D/g, "")}${(c.phone || "").replace(/\D/g, "")}`;
  return (
    <div className="space-y-5">
      <Field label="Correo electrónico" testId="contacto-email" type="email" value={c.email}
        onChange={(v) => setC({ email: v })} />
      <div className="grid grid-cols-[100px_1fr] gap-3">
        <Field label="Código país" testId="contacto-codigo" value={c.countryCode}
          onChange={(v) => setC({ countryCode: v })} />
        <Field label="Teléfono" testId="contacto-telefono" value={c.phone}
          onChange={(v) => setC({ phone: v })} />
      </div>
      <p className="text-xs text-neutral-500">
        Enlace de WhatsApp generado automáticamente:{" "}
        <span data-testid="whatsapp-preview" className="text-[#0057FF] font-medium">
          {(c.phone || "").replace(/\D/g, "") ? `https://wa.me/${digits}` : "— agrega un teléfono —"}
        </span>
      </p>
      <hr className="border-neutral-200" />
      <Field label="Instagram" testId="red-instagram" value={s.instagram || ""} placeholder="https://www.instagram.com/..."
        onChange={(v) => setS({ instagram: v.trim() || null })} />
      <Field label="TikTok" testId="red-tiktok" value={s.tiktok || ""} placeholder="https://www.tiktok.com/@..."
        onChange={(v) => setS({ tiktok: v.trim() || null })} />
      <Field label="YouTube" testId="red-youtube" value={s.youtube || ""} placeholder="https://www.youtube.com/@..."
        onChange={(v) => setS({ youtube: v.trim() || null })} />
      <p className="text-xs text-neutral-500">Solo se muestran en la página los perfiles con enlace.</p>
    </div>
  );
};
